'use client';

import { InternalLink } from '../../components/Clickables/InternalLink/InternalLink';
import { Container } from '../../components/Container/Container';
import { DownloadAppHorizontalCTA } from '../../components/CTAs/DownloadAppHorizontalCTA/DownloadAppHorizontalCTA';
import { Heading } from '../../components/Heading/Heading';
import { LoadingIndicator } from '../../components/LoadingIndicator/LoadingIndicator';
import { Redirect } from '../../components/Redirect/Redirect';
import { UserDetails } from '../../components/UserDetails/UserDetails';
import { useIsMobileDevice } from '@hooks/useIsMobileDevice';
import { useUserInfo } from '@domain/user/useUserInfo';
import { URLParameters } from '../Authentication/constants';
import { useCurrentURL } from '@hooks/useCurrentURL';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export const Profile = () => {
  const { user, isLoggedIn, isLoadingUser, isPremium } = useUserInfo();
  const isMobileDevice = useIsMobileDevice();
  const clientHasRendered = useClientHasRendered();
  const { addParameters } = useCurrentURL();
  const loginLink = addParameters({ [URLParameters.Flow]: 'login' });

  if (clientHasRendered && !isLoadingUser && !isLoggedIn) {
    return <Redirect to={loginLink} />;
  }

  return (
    <>
      <Container>
        {user ? (
          <div className="pt-8 sm:pt-14">
            <Heading className="my-0 text-center" as="h1">
              Account settings
            </Heading>
            <UserDetails />
            <div className="my-16 text-center">
              {isPremium && (
                <>
                  <Heading variant="2xs" className="text-trench py-4">
                    You are a Fishbrain Pro member
                  </Heading>
                  <InternalLink className="text-base" variant="buttonPro" to="pro/overview">
                    Your Pro membership
                  </InternalLink>
                </>
              )}
            </div>
          </div>
        ) : (
          <LoadingIndicator />
        )}
      </Container>
      {!isMobileDevice && isPremium && (
        <Container>
          <DownloadAppHorizontalCTA className="mb-12" />
        </Container>
      )}
    </>
  );
};
